import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { brandPath, mainSiteHref } from '../utils/brandRouting';
import { products } from '../data/siteContent';

const NUTRISCAN = products.find((product) => product.id === 'nutriscan');

export default function NSNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const backHref = mainSiteHref();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn, { passive: true }); fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <nav className={`ns-navbar${scrolled ? ' scrolled' : ''}`} data-testid="ns-navbar">
        <div className="wrap">
          <Link to={brandPath('nutriscan')} className="ns-brand">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect width="28" height="28" rx="7" fill="#16A34A"/>
              <path d="M3 7V3h4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M25 7V3h-4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M3 21v4h4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M25 21v4h-4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              <rect x="6" y="6" width="2" height="16" fill="white" opacity="0.85"/>
              <rect x="10" y="6" width="1" height="16" fill="white" opacity="0.6"/>
              <rect x="13" y="6" width="2" height="16" fill="white" opacity="0.85"/>
              <rect x="17" y="6" width="1" height="16" fill="white" opacity="0.6"/>
              <rect x="20" y="6" width="2" height="16" fill="white" opacity="0.85"/>
              <path d="M6 20 L10 15 L14 17.5 L18 12 L22 14.5" stroke="#86EFAC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="ns-brand-name">Nutri<span>Scan</span></span>
          </Link>

          <div className="nav-links">
            <Link to={brandPath('nutriscan', '/privacy')} className="ns-nav-link">Privacy</Link>
            <Link to={brandPath('nutriscan', '/terms')} className="ns-nav-link">Terms</Link>
            <Link to={brandPath('nutriscan', '/faq')} className="ns-nav-link">FAQ</Link>
            <Link to={brandPath('nutriscan', '/account-deletion')} className="ns-nav-link">Delete account</Link>
            {backHref
              ? <a href={backHref} className="ns-back-link"><i className="fas fa-arrow-left"></i> TickleApps</a>
              : <Link to="/" className="ns-back-link"><i className="fas fa-arrow-left"></i> TickleApps</Link>}
          </div>

          <div className="nav-right">
            <a href={NUTRISCAN.storeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-ns btn-sm" data-testid="ns-download-btn">{NUTRISCAN.storeLabel}</a>
          </div>
          <button
            className={`hamburger${open ? ' open' : ''}`}
            onClick={() => setOpen(o => !o)}
            aria-label="Menu"
            aria-expanded={open}
            aria-controls="ns-nav-drawer"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div id="ns-nav-drawer" className={`nav-drawer${open ? ' open' : ''}`} style={{ background: '#FAFEFB' }}>
        <Link to={brandPath('nutriscan', '/privacy')} className="ns-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Privacy</Link>
        <Link to={brandPath('nutriscan', '/terms')} className="ns-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Terms</Link>
        <Link to={brandPath('nutriscan', '/faq')} className="ns-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>FAQ</Link>
        <Link to={brandPath('nutriscan', '/account-deletion')} className="ns-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Delete account</Link>
        {backHref
          ? <a href={backHref} className="ns-back-link" style={{ fontSize: '0.9rem', padding: '12px 16px' }}><i className="fas fa-arrow-left"></i> Back to TickleApps</a>
          : <Link to="/" className="ns-back-link" style={{ fontSize: '0.9rem', padding: '12px 16px' }}><i className="fas fa-arrow-left"></i> Back to TickleApps</Link>}
        <a href={NUTRISCAN.storeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-ns" style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }}>{NUTRISCAN.storeLabel}</a>
      </div>
    </>
  );
}
